/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* Copyright 2015 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { unreachable } from './shared/util.js';

class BaseWasmFactory {
    baseUrl: null;

    baseWasm: boolean;

    baseTarget: EventTarget = new EventTarget();

    constructor({ baseUrl = null }) {
        if (this.constructor === BaseWasmFactory) {
            unreachable('Cannot initialize BaseWasmFactory.');
        }
        this.baseTarget.dispatchEvent(new CustomEvent('init'));
        this.baseWasm = false;
        this.baseUrl = baseUrl;
    }

    async fetch({ filename }: any) {
        if (!this.baseUrl) {
            throw new Error(
                'Ensure that the `wasmUrl` API parameter is provided.'
            );
        }
        if (!filename) {
            throw new Error('Wasm filename must be specified.');
        }
        const url = `${this.baseUrl}${filename}`;

        return this._fetch(url).catch((reason) => {
            throw new Error(`Unable to load wasm data at: ${url}`);
        });
    }

    /**
     * @ignore
     * @returns {Promise<Uint8Array>}
     */
    async _fetch(url: string): Promise<Uint8Array | void> {
        unreachable('Abstract method `_fetch` called.');
    }
}

export { BaseWasmFactory };
